import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/config-global';
import NotesHistory from 'src/sections/home/notes-history';

// ----------------------------------------------------------------------

const metadata = { title: `Exercise Notes History |  ${CONFIG.appName}` };

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>

      <NotesHistory />
    </>
  );
}
